/**
 * Default constants for schedule view settings.
 * These are separated into their own file to avoid circular dependencies,
 * since UrlFactory needs to import these constants but is also imported by
 * files that depend on the orchestrator.
 */

import {
    ScheduleCalendarType,
    ScheduleCalendarTypes,
    ScheduleOverViewType,
    ScheduleOverViewTypes
} from "sh-models";

// Default schedule view settings
export const defaultScheduleCalendarType: ScheduleCalendarType = ScheduleCalendarTypes.Week; // The Schedules page displays in Week mode by default
export const defaultScheduleOverviewType: ScheduleOverViewType = ScheduleOverViewTypes.PeopleView; // The Schedules page displays Members view by default
